import React from "react";
import {Grid} from "@mui/material";
import {BaseInput} from "../../../../designSystem/components/BaseInput";

export const GlucoseForm = ({
  measurement,
  onChangeMeasurement,
}) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <BaseInput
        type="number"
        onChange={e => onChangeMeasurement({...measurement, glucose: e.target.value})}
        value={measurement.glucose}
        placeholder="血糖(mg/dl)"
      />
    </Grid>
  </Grid>
)